import FilterDialog from './Dialog';
import { useSelector } from 'react-redux';
import FilterButton from '../../../../filter/FilterButton';

const FilterButtonUser = ({ disabled = false, filteredRolesId = [], dataRoles = [], dataYears = [], type }) => {
  const open = useSelector((state) => state?.filter?.builderUsers?.open || false);

  return (
    <>
      <FilterButton module='builderUsers' keysFilter={['yearLevelId', 'rolesId']} disabled={disabled} />
      {open && !disabled && (
        <FilterDialog filteredRolesId={filteredRolesId} dataRoles={dataRoles} dataYears={dataYears} type={type} />
      )}
    </>
  );
};
export default FilterButtonUser;
